module.exports = __webpack_public_path__ + "staticcomp/img/top.6a51e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/3/top.jpg
// module id = rigy
// module chunks = 39